import ControlViewModel from "@/ViewModels/ControlViewModel";
import { IControlViewModelConstructorParameter } from "#/CoreFrameInterfaces";
import ComponentManager from "@/Management/ComponentManager";

export interface IWebComponentControlViewModelConstructorParameters extends IControlViewModelConstructorParameter {}

export default class WebComponentControlViewModel extends ControlViewModel {
    constructor(params: IWebComponentControlViewModelConstructorParameters) {
        super(params);
    }
}

ComponentManager.setViewModel('WebComponentControl', WebComponentControlViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions')